<template>
  <div class="mt-2">
        <div class="col-12">

          <table class="table table-striped projects">
            <thead>
              <tr>
                <th>Müşteri Kodu</th>
                <th>Zamanı</th>
                <th>İşlem Tipi</th>
                <th>Tutar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in data" :key="index">
                <td>{{ data.customerCode }}</td>
                <td>
                  {{ data.date | DateFormat }}
                </td>
                <td>
                  {{ data.depositType }}
                </td>
                <td>
                  <span>
                    {{ data.amount || 0 }} TL
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  }, filters: {
    DateFormat(value) {
      if (!value) return "Giriş Yapılmamış";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    },
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/UserProfile/UserDeposits.vue